import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import {
  getProgressPercentofprogress,
  updateProgressPercentofprogress,
  saveProgressFeedback,
  updateProgressFeedback,
  deleteProgressFeedback,
} from '../../redux/actions/projectProgress'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getSchemaSidebar } from '../../redux/actions/sidebar'
import InputNumberForm from '../../components/forms/input/InputNumberForm'
import CommentForm from './CommentForm'
import CommentView from './CommentView'
import ButtonPanel from '../ButtonPanel'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'
import { budgetFormat } from '../../utils/formatterUtil'

export default function PercentOfProgressWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressId, setProgressId] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    // console.log('PercentOfProgressWidget', _schema, 'progressId', progressId)
    setProgressId(progressId)
    setFormSchema(_schema)
  }, [_schema])

  const handleCallService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call update.')
      const response = await updateProgressPercentofprogress(projectId, projectProgressId, request)

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallCommentService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (request.value.value || request.value.id) {
        if (request.value.value) {
          let response

          if (request.value.id) {
            console.log('call update.')
            response = await updateProgressFeedback(projectId, projectProgressId, request)
          } else {
            console.log('call save.')
            response = await saveProgressFeedback(projectId, projectProgressId, request)
          }

          console.log('response', response)
          if (response) {
            onChangeIsEdit(false)
            let _schema = formSchema
            _schema.comment = response
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        } else {
          let deleteResult = await deleteProgressFeedback(
            projectId,
            projectProgressId,
            request.value.id
          )

          if (deleteResult == 200) {
            let _schema = await getProgressPercentofprogress(projectId, projectProgressId)
            console.log('getProgressPercentofprogress', _schema)
            onChangeIsEdit(false)
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        }
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      value: data.percentOfProgress,
    }

    console.log('request body', request)
    handleCallService(request, progressId)
    // formSchema.percentOfProgress.value = data.percentOfProgress
    // onChangeIsEdit(false)
  }

  const onSubmitComment = (data) => {
    console.log('onSubmitComment', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      masterSubjectId: formSchema.comment.masterSubjectId,
      value: {
        id: formSchema.comment.id,
        value: data.comment,
      },
    }

    console.log('request body', request)
    handleCallCommentService(request, progressId)
  }
  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema?.comment?.enableEdit ? (
        <>
          {formSchema.beforePercentOfProgress && (
            <p style={{ marginBottom: 10 }}>
              {formSchema.beforePercentOfProgress.label}{' '}
              {budgetFormat(formSchema.beforePercentOfProgress.value)}{' '}
              {formSchema.beforePercentOfProgress.postLabel}
            </p>
          )}
          <p>
            {formSchema.percentOfProgress.label}{' '}
            {budgetFormat(formSchema.percentOfProgress.value || formSchema.percentOfProgress.hint)}{' '}
            {formSchema.percentOfProgress.postLabel}
          </p>
          <hr />
          {isEdit ? (
            <CommentForm
              schema={formSchema.comment}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <div>
              <CommentView schema={formSchema.comment} />
            </div>
          )}
        </>
      ) : (
        <>
          <WarningMessage style={{ marginBottom: 10 }} message={formSchema?.comment?.value} />

          {formSchema.beforePercentOfProgress && (
            <p style={{ marginBottom: 10 }}>
              {formSchema.beforePercentOfProgress.label}{' '}
              {budgetFormat(formSchema.beforePercentOfProgress.value)}{' '}
              {formSchema.beforePercentOfProgress.postLabel}
            </p>
          )}

          {isEdit ? (
            <InputNumberForm
              schema={formSchema.percentOfProgress}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              labelMdLg={8}
              inputMdlg={4}
              min={0}
              max={100}
            />
          ) : (
            <p>
              {formSchema.percentOfProgress.label}{' '}
              {budgetFormat(
                formSchema.percentOfProgress.value || formSchema.percentOfProgress.hint
              )}{' '}
              {formSchema.percentOfProgress.postLabel}
            </p>
          )}
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={
              formSchema?.comment?.enableEdit
                ? formSchema?.comment?.buttonText
                : formSchema.buttonText
            }
            onSave={handleSubmit(formSchema.comment?.enableEdit ? onSubmitComment : onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}

// const schema = {
//   header: 'การประเมินความสำเร็จของโครงการร้อยละ',
//   buttonText: 'การประเมินความสำเร็จของโครงการ',
//   percentOfProgress: {
//     name: 'percentOfProgress',
//     label: 'ประเมินความก้าวหน้าในการดำเนินการตามแผน',
//     hint: '00.00',
//     postLabel: '%',
//     validators: [
//       {
//         type: 'REQUIRED',
//         value: null,
//         errorMessage: 'กรุณากรอก ประเมินความก้าวหน้าในการดำเนินการตามแผน',
//       },
//     ],
//   },
// }
